module.exports = __webpack_public_path__ + "img/slider_tag.7b2c37ff.png";